<ng-container *ngIf="hasResetToken$ | async; else steps">
  <hfc-signup></hfc-signup>
</ng-container>
<ng-template #steps>
  <hfc-sign-up-steps></hfc-sign-up-steps>
</ng-template>
